import * as React from 'react';
import { connect } from 'react-redux';
import { get } from 'lodash';

import BaseCampaignPage from './BaseCampaignPage';
import CampaignSubcampaigns from 'modules/campaigns/components/campaign-subcampaigns/CampaignSubcampaigns';

import { t } from 'utils/language';
import {
  PARTICIPANT_TYPES_ORDER,
  isParticipantTypeSupported
} from 'utils/campaignParticipants';

import type { Params } from 'types';

type PARTICIPANTS_TABS = 'shortlisted' | 'pending' | 'agreed' | 'rejected';

type StateProps = {
  nextSelectedTypeFromParams: PARTICIPANTS_TABS
};

type OwnProps = {
  params: Params & {
    participantType: string
  }
};

type Props = StateProps & OwnProps;

type State = {
  selectedType: PARTICIPANTS_TABS
};

function getSelectedTab(nextProps) {
  const stateFromURL = get(nextProps, 'params.participantType', null);

  return isParticipantTypeSupported(stateFromURL) ? stateFromURL : PARTICIPANT_TYPES_ORDER[0];
}

class CampaignSubcampaignsPage extends React.PureComponent<Props, State> {
  state = {
    selectedType: getSelectedTab(this.props)
  };

  componentDidUpdate() {
    const { nextSelectedTypeFromParams } = this.props;
    const { selectedType } = this.state;

    if (nextSelectedTypeFromParams !== selectedType) {
      this.setState({ // eslint-disable-line react/no-did-update-set-state
        selectedType: nextSelectedTypeFromParams
      });
    }
  }

  render(): React.ReactNode {
    const { params } = this.props;
    const { selectedType } = this.state;

    return (
      <BaseCampaignPage
        params={params}
        documentTitle={t('campaign_subnavigation_participants')}
        pageType="participants"
      >
        <CampaignSubcampaigns
          campaignId={Number(params.id)}
          selectedParticipantsType={selectedType}
          isEditMode={false}
        />
      </BaseCampaignPage>
    );
  }
}

const mapStateToProps = (_, props): StateProps => ({
  nextSelectedTypeFromParams: getSelectedTab(props)
});

export default connect(mapStateToProps)(CampaignSubcampaignsPage);
